function initProductProduct() {
  $(".product__images .product__image").click(function () {
    $(".product__images .active").removeClass("active");
    $(this).addClass("active");

    $(".product__image-wrapper .product__image").removeClass("active");
    $("#" + $(this).data("index")).addClass("active");
  });
}
